import { CBadge, CContainer } from '@coreui/react-pro';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CART_TYPES, LOCAL_ORG_USER } from '../../../../../../constants';
import { useActiveProduct } from '../../../../../../helpers/customHook';
import { fetchSubscriberLimitProductEventsRequest } from '../../../../../../helpers/handleFunctionGeneral';
import { formatEventSingleDateTime, tryParseJSON } from '../../../../../../utils';
import TrainingIntro from '../../../../../General/TrainingIntro/TrainingIntro';
import { fetchSubscriberProductsRequest } from '../../../../Subscriber/Products/actions';
import { fetchListOrganizationSeatsRequest } from '../../OrganizationSeats/actions';
import TrainingCourse from '../../TrainingSeatDetails/TrainingCourse';

const TrainingEventDetails = () => {
     const dispatch = useDispatch();
     const { eventId } = useParams();
     const [productEvents, setProductEvents] = useState();
     const products = useSelector((state) => state.subscriber.products.list);
     const product = useActiveProduct();
     const relatedProduct = products?.find((item) => item.id === product?.relatedProductProductId);

     const eventDetails = productEvents ? productEvents.find((event) => event.id === eventId) : null;

     const orgUserLocalStorage = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const organizationId = orgUserLocalStorage.organizationId;

     const listOrganizationSeats = useSelector((state) => state.subscriber.listOrganizationSeats);

     const fetchListOrganizationSeats = () => {
          const isNeedFetchData = !listOrganizationSeats || listOrganizationSeats.some((seat) => seat.organizationId !== organizationId);

          if (organizationId && isNeedFetchData) {
               dispatch(fetchListOrganizationSeatsRequest(organizationId));
          }
     };

     useEffect(() => {
          fetchListOrganizationSeats();
     }, [organizationId, listOrganizationSeats]); // eslint-disable-line react-hooks/exhaustive-deps

     //Get all product Events by Product product.id
     const fetchProductEvents = () => {
          if (product?.id) {
               dispatch(
                    fetchSubscriberLimitProductEventsRequest({
                         id: product?.id,
                         organizationId,
                         setFunction: setProductEvents,
                    })
               );
          }
     };

     const fetchProducts = () => {
          if (!products.length) {
               dispatch(fetchSubscriberProductsRequest());
          }
     };
     useEffect(() => {
          fetchProducts();
          fetchProductEvents();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <>
               {product && (
                    <section className="training-event-detail">
                         <CContainer>
                              <div className="container-content">
                                   <TrainingIntro title={product.publishName} />

                                   <div className="badge-and-event-time d-flex ">
                                        <CBadge className="badge badge-pill badge-outline-primary">ONLINE TRAINING</CBadge>
                                        {eventDetails?.startAt && <p>{formatEventSingleDateTime(eventDetails?.startAt)}</p>}
                                   </div>

                                   {[CART_TYPES.ORGANIZATION, CART_TYPES.BOTH].includes(product.purchaseType) && <TrainingCourse product={product} />}

                                   {relatedProduct && [CART_TYPES.ORGANIZATION, CART_TYPES.BOTH].includes(relatedProduct.purchaseType) && (
                                        <TrainingCourse product={relatedProduct} />
                                   )}
                              </div>
                         </CContainer>
                    </section>
               )}
          </>
     );
};

export default TrainingEventDetails;
